import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

function FaqList({ items, testId, prefix }) {
  return (
    <Accordion type="single" collapsible className="rounded-3xl bg-white border border-splash-sand px-6">
      {items.map((it, i) => (
        <AccordionItem key={it.q} value={`${prefix}-${i}`} className="border-splash-sand last:border-b-0">
          <AccordionTrigger data-testid={`${testId}-q-${prefix}-${i}`} className="text-left font-semibold text-splash-green hover:no-underline">{it.q}</AccordionTrigger>
          <AccordionContent className="text-splash-green/80 leading-relaxed text-base">{it.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}

// Pass `items` (flat list) or `categories` ([{ category, items }]).
export default function ProgramFaq({ items, categories, title = 'Frequently asked questions', testId }) {
  const groups = categories || [{ category: null, items }];
  return (
    <section className="py-20" data-testid={testId}>
      <div className="max-w-4xl mx-auto px-6">
        <div className="uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">FAQ</div>
        <h2 className="font-display font-bold text-3xl md:text-4xl text-splash-green mb-8">{title}</h2>
        <div className="space-y-8">
          {groups.map((g, gi) => (
            <div key={g.category || gi}>
              {g.category && <h3 className="mb-3 text-sm uppercase tracking-widest font-semibold text-splash-teal">{g.category}</h3>}
              <FaqList items={g.items} testId={testId} prefix={gi} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
